// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-container{
    display: flex;
    flex-direction: column;
    padding-top: 110px;
}

.page-info{
    display: flex;
    flex-direction: column;
}

.page-info h1{
    font-family: 'Philosopher',serif;
    font-size: 24px;
    font-weight: 500;
    margin: 0px;
    color:#E42727;
}

.page-info-navigation{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.page-info-navigation-icons{
    margin:10px;
}

.page-info-navigation h5{
    font-family: 'Philosopher', sans-serif;
        font-size: 14px;
        font-weight: 500;
        margin: 10px;

}


.cart{
    
    display: flex;
    flex-direction: row;
    padding: 50px;
    
   
}

.cart h1{
    text-align: left;
}

.cart table {
    width: 60vw;
    border-collapse: collapse;
   
    
    
}

.empty-cart-message{
    width:100vw;
    display:flex;
    justify-content: center;
    align-items: center;
}

th,
td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: center;
    font-size: large;
    margin:0 auto;
    
}

td{
    text-align: center;
    vertical-align: middle;

}

th  {
    
    font-family: 'Poppins',sans-serif;
    font-size: 15px;
    /* color:#666666; */
    letter-spacing: 1px;
    font-weight: 400;
}

.unit-price{
    font-family: 'Inter',sans-serif;
    font-size: 14px;
    font-weight: 700;
    color:#77b500;
}

.quantity-controls{
    display: flex;
        flex-direction: row;
        width: 100px;
        height: 40px;
        border: #666666;
        border-style: solid;
        border-width: 1px;
        
        justify-content:left;
        align-items: center;
        margin: 10px;
    
}

.quantity-controls p{
    margin:0px 20px;
    font-size: 14px;
    font-size: 'Inter',sans-serif;
}
.quantity-controls button{
    border:none;
    background-color: #fff;
    /* color:#333; */
    font-size: larger;


    
}

.cart-image{
    width:60px;
    
}

.product-title-image{
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Inter',sans-serif;
    font-size: 14px;
    font-weight: 400;
    /* color:#333; */
    text-align: center;
    
}

.cart-totals{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
    justify-content: center;
    justify-content: center;
    width:400px;
}

.cart-totals h1{
    text-align: center;
    font-family: 'Philosopher',serif;
    font-size: 24px;
}

.cart-totals h2{
    text-align: center;
    font-size: 26px;
    font-family: 'Philospher',serif;
    color:#77b500;
    margin-top: 10px;
}

.cart-totals p{
    font-family: 'Poppins',sans-serif;
    letter-spacing: 1px;
    font-size: 14px;
    /* color:#666666; */
}

.cart-totals button{
       background-color: #e42727;
        width: 80%;
        height: 40px;
        border-radius: 25px;
        color: #ffffff;
        font-family: 'Philosopher', serif;
        margin-left: 0px;
        margin-top: 20px;
        border:none;
        font-size: 20px;
        transition: transform 0.3s ease;
        cursor: pointer;
        position: relative;
            overflow: hidden;
            cursor: pointer;
        
            z-index: 0;
}

 








 .cart-totals button::after {
     /* this is what all  will be done when mouse outs from the button */
     content: "";
     position: absolute;
     left: 0;
     top: 0;
     height: 100%;
     width: 100%;
     background-color: #ffa406;
     z-index: -1;

     transition: 0.3s ease all;
     transform: scale(0, 1);

     /* this is you are to change for diffirent transition; */

     transform-origin: bottom left;
     transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
     transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
 }



 .cart-totals button:hover::after {
     transform: scale(1, 1);
     transform-origin: top left;
 }

@media screen and (max-width:768px){
    .cart-container {
            display: flex;
            flex-direction: column;
            padding-top: 180px;
        }
        .cart {
    
            display: flex;
            flex-direction: column;
            width:90%;
            padding: 20px;
            margin-left: 0px;
            padding-left: 20px;
    
    
        }
        .cart table {
            width: 90%;
            border-collapse: collapse;
            display: flex;
            flex-direction: column;
            overflow: scroll;
            
    
        }
        .cart tr{
            display: flex;
            flex-direction: row;
            
        }
        .cart th,td{
            min-width:150px;
            box-sizing: border-box;
            text-align: center;
            align-items: center;
            justify-content: center;
            display: flex;

        }
        .cart-totals {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 20px 0px;
            justify-content: center;
            justify-content: center;
            width: 100%;
        }
        .cart-class button{
            margin-bottom: 0px;
        }
        .empty-cart-message{
            width:90vw;
        }
        
}



`, "",{"version":3,"sources":["webpack://./src/Styles/Cart.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sCAAsC;QAClC,eAAe;QACf,gBAAgB;QAChB,YAAY;;AAEpB;;;AAGA;;IAEI,aAAa;IACb,mBAAmB;IACnB,aAAa;;;AAGjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;;;;AAI7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;;AAEjB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;;AAE1B;;AAEA;;IAEI,iCAAiC;IACjC,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;QACT,mBAAmB;QACnB,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,mBAAmB;QACnB,iBAAiB;;QAEjB,oBAAoB;QACpB,mBAAmB;QACnB,YAAY;;AAEpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;;;;AAIrB;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;OACO,yBAAyB;QACxB,UAAU;QACV,YAAY;QACZ,mBAAmB;QACnB,cAAc;QACd,iCAAiC;QACjC,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,+BAA+B;QAC/B,eAAe;QACf,kBAAkB;YACd,gBAAgB;YAChB,eAAe;;YAEf,UAAU;AACtB;;;;;;;;;;;CAWC;KACI,mEAAmE;KACnE,WAAW;KACX,kBAAkB;KAClB,OAAO;KACP,MAAM;KACN,YAAY;KACZ,WAAW;KACX,yBAAyB;KACzB,WAAW;;KAEX,yBAAyB;KACzB,sBAAsB;;KAEtB,wDAAwD;;KAExD,6BAA6B;KAC7B,0DAA0D;KAC1D,0DAA0D;CAC9D;;;;CAIA;KACI,sBAAsB;KACtB,0BAA0B;CAC9B;;AAED;IACI;YACQ,aAAa;YACb,sBAAsB;YACtB,kBAAkB;QACtB;QACA;;YAEI,aAAa;YACb,sBAAsB;YACtB,SAAS;YACT,aAAa;YACb,gBAAgB;YAChB,kBAAkB;;;QAGtB;QACA;YACI,UAAU;YACV,yBAAyB;YACzB,aAAa;YACb,sBAAsB;YACtB,gBAAgB;;;QAGpB;QACA;YACI,aAAa;YACb,mBAAmB;;QAEvB;QACA;YACI,eAAe;YACf,sBAAsB;YACtB,kBAAkB;YAClB,mBAAmB;YACnB,uBAAuB;YACvB,aAAa;;QAEjB;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,gBAAgB;YAChB,uBAAuB;YACvB,uBAAuB;YACvB,WAAW;QACf;QACA;YACI,kBAAkB;QACtB;QACA;YACI,UAAU;QACd;;AAER","sourcesContent":[".cart-container{\n    display: flex;\n    flex-direction: column;\n    padding-top: 110px;\n}\n\n.page-info{\n    display: flex;\n    flex-direction: column;\n}\n\n.page-info h1{\n    font-family: 'Philosopher',serif;\n    font-size: 24px;\n    font-weight: 500;\n    margin: 0px;\n    color:#E42727;\n}\n\n.page-info-navigation{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.page-info-navigation-icons{\n    margin:10px;\n}\n\n.page-info-navigation h5{\n    font-family: 'Philosopher', sans-serif;\n        font-size: 14px;\n        font-weight: 500;\n        margin: 10px;\n\n}\n\n\n.cart{\n    \n    display: flex;\n    flex-direction: row;\n    padding: 50px;\n    \n   \n}\n\n.cart h1{\n    text-align: left;\n}\n\n.cart table {\n    width: 60vw;\n    border-collapse: collapse;\n   \n    \n    \n}\n\n.empty-cart-message{\n    width:100vw;\n    display:flex;\n    justify-content: center;\n    align-items: center;\n}\n\nth,\ntd {\n    padding: 10px;\n    border: 1px solid #ddd;\n    text-align: center;\n    font-size: large;\n    margin:0 auto;\n    \n}\n\ntd{\n    text-align: center;\n    vertical-align: middle;\n\n}\n\nth  {\n    \n    font-family: 'Poppins',sans-serif;\n    font-size: 15px;\n    /* color:#666666; */\n    letter-spacing: 1px;\n    font-weight: 400;\n}\n\n.unit-price{\n    font-family: 'Inter',sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    color:#77b500;\n}\n\n.quantity-controls{\n    display: flex;\n        flex-direction: row;\n        width: 100px;\n        height: 40px;\n        border: #666666;\n        border-style: solid;\n        border-width: 1px;\n        \n        justify-content:left;\n        align-items: center;\n        margin: 10px;\n    \n}\n\n.quantity-controls p{\n    margin:0px 20px;\n    font-size: 14px;\n    font-size: 'Inter',sans-serif;\n}\n.quantity-controls button{\n    border:none;\n    background-color: #fff;\n    /* color:#333; */\n    font-size: larger;\n\n\n    \n}\n\n.cart-image{\n    width:60px;\n    \n}\n\n.product-title-image{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Inter',sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    /* color:#333; */\n    text-align: center;\n    \n}\n\n.cart-totals{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 20px;\n    justify-content: center;\n    justify-content: center;\n    width:400px;\n}\n\n.cart-totals h1{\n    text-align: center;\n    font-family: 'Philosopher',serif;\n    font-size: 24px;\n}\n\n.cart-totals h2{\n    text-align: center;\n    font-size: 26px;\n    font-family: 'Philospher',serif;\n    color:#77b500;\n    margin-top: 10px;\n}\n\n.cart-totals p{\n    font-family: 'Poppins',sans-serif;\n    letter-spacing: 1px;\n    font-size: 14px;\n    /* color:#666666; */\n}\n\n.cart-totals button{\n       background-color: #e42727;\n        width: 80%;\n        height: 40px;\n        border-radius: 25px;\n        color: #ffffff;\n        font-family: 'Philosopher', serif;\n        margin-left: 0px;\n        margin-top: 20px;\n        border:none;\n        font-size: 20px;\n        transition: transform 0.3s ease;\n        cursor: pointer;\n        position: relative;\n            overflow: hidden;\n            cursor: pointer;\n        \n            z-index: 0;\n}\n\n \n\n\n\n\n\n\n\n\n .cart-totals button::after {\n     /* this is what all  will be done when mouse outs from the button */\n     content: \"\";\n     position: absolute;\n     left: 0;\n     top: 0;\n     height: 100%;\n     width: 100%;\n     background-color: #ffa406;\n     z-index: -1;\n\n     transition: 0.3s ease all;\n     transform: scale(0, 1);\n\n     /* this is you are to change for diffirent transition; */\n\n     transform-origin: bottom left;\n     transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n     transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n }\n\n\n\n .cart-totals button:hover::after {\n     transform: scale(1, 1);\n     transform-origin: top left;\n }\n\n@media screen and (max-width:768px){\n    .cart-container {\n            display: flex;\n            flex-direction: column;\n            padding-top: 180px;\n        }\n        .cart {\n    \n            display: flex;\n            flex-direction: column;\n            width:90%;\n            padding: 20px;\n            margin-left: 0px;\n            padding-left: 20px;\n    \n    \n        }\n        .cart table {\n            width: 90%;\n            border-collapse: collapse;\n            display: flex;\n            flex-direction: column;\n            overflow: scroll;\n            \n    \n        }\n        .cart tr{\n            display: flex;\n            flex-direction: row;\n            \n        }\n        .cart th,td{\n            min-width:150px;\n            box-sizing: border-box;\n            text-align: center;\n            align-items: center;\n            justify-content: center;\n            display: flex;\n\n        }\n        .cart-totals {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            margin: 20px 0px;\n            justify-content: center;\n            justify-content: center;\n            width: 100%;\n        }\n        .cart-class button{\n            margin-bottom: 0px;\n        }\n        .empty-cart-message{\n            width:90vw;\n        }\n        \n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
